import { __awaiter, __generator } from "tslib";
import { TransactionMode } from '@tencent/memoire-core';
import { TableOperationUtils } from '../model';
import { CollectionNotFoundError, DataMigrationError } from '../error/errors';
import { CollectionDataMigrationPlanner } from './data-migration-planner';
import { SystemTableHelper } from '../utils/system-table-helper';
import { DATABASE_DEFAULT_OPEN_VERSION } from '../utils/constant';
var LazyDataMigrationProcessor = /** @class */ (function () {
    function LazyDataMigrationProcessor(migrationManager) {
        this.migrationManager = migrationManager;
        this.upgradedFlag = new Map();
    }
    /**
     * Perform onDataUpgrade() handle insides specific model class to upgrade data inside db.
     * It will skip when there's no need to perform upgrade or the upgrade is already performed.
     *
     * @returns a boolean value indicates whether it's the first time to execute upgrade
     *
     */
    LazyDataMigrationProcessor.prototype.executeDataUpgrade = function (modelClass, db, state, onDidFinish) {
        if (onDidFinish === void 0) { onDidFinish = function () { }; }
        return __awaiter(this, void 0, void 0, function () {
            var collection, collectionSchema;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        collection = TableOperationUtils.getTableName(modelClass);
                        // if model has already upgraded, skip;
                        if (this.upgradedFlag.get(collection)) {
                            return [2 /*return*/];
                        }
                        collectionSchema = this.getCollectionSchema(collection, state);
                        if (!this.isNeedExecuteDataUpgrade(collectionSchema.expect, collectionSchema.actual)) {
                            this.upgradedFlag.set(collection, true);
                            return [2 /*return*/, onDidFinish()];
                        }
                        return [4 /*yield*/, this.executeUpgrade(collection, db, state, collectionSchema.expect, collectionSchema.actual, modelClass)];
                    case 1:
                        _a.sent();
                        this.upgradedFlag.set(collection, true);
                        return [2 /*return*/, onDidFinish()];
                }
            });
        });
    };
    /**
     * check collection is need to be upgraded by compare dataVersion
     * @param expect
     * @param actual
     * @returns false if actual collection dataVersion is equal expect dataVersion, or collection has no data
     */
    LazyDataMigrationProcessor.prototype.isNeedExecuteDataUpgrade = function (expect, actual) {
        if (!(actual === null || actual === void 0 ? void 0 : actual.dataVersion) || expect.dataVersion === actual.dataVersion) {
            return false;
        }
        return true;
    };
    /**
     * execute data migration actions which generate by auto or manual, more detail see @CollectionDataMigrationPlanner
     */
    LazyDataMigrationProcessor.prototype.executeUpgrade = function (collection, db, state, expectedSchema, actualSchema, modelClass) {
        return __awaiter(this, void 0, void 0, function () {
            var plan, migrations, transaction, hasError, newVersion, oldVersion, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        plan = new CollectionDataMigrationPlanner(expectedSchema, actualSchema, modelClass);
                        this.migrationManager.use(plan);
                        migrations = this.migrationManager.buildMigration(state);
                        return [4 /*yield*/, db.transaction([collection, SystemTableHelper.getSystemTableSchema().name], TransactionMode.READ_WRITE)];
                    case 1:
                        transaction = _a.sent();
                        hasError = false;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, 8, 11]);
                        newVersion = state.schema.expect.version || DATABASE_DEFAULT_OPEN_VERSION;
                        return [4 /*yield*/, SystemTableHelper.getTableDataVersion(TableOperationUtils.getTableName(modelClass), transaction)];
                    case 3:
                        oldVersion = _a.sent();
                        // If the data version in the database is consistent with the expected version,
                        // it proves that the data has been updated(may be in other tab), and the current migration operation needs to be rollback here.
                        if (oldVersion === newVersion) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.migrationManager.executeDataMigration(db, migrations, transaction)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, SystemTableHelper.updateCollectionDataVersion(newVersion, transaction, modelClass)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 11];
                    case 6:
                        err_1 = _a.sent();
                        hasError = true;
                        return [4 /*yield*/, transaction.rollback()];
                    case 7:
                        _a.sent();
                        throw new DataMigrationError({ oldVersion: actualSchema.dataVersion, newVersion: expectedSchema.dataVersion }, err_1);
                    case 8:
                        if (!!hasError) return [3 /*break*/, 10];
                        return [4 /*yield*/, transaction.commit()];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    LazyDataMigrationProcessor.prototype.getCollectionSchema = function (collection, state) {
        var _a = state.schema, expect = _a.expect, actual = _a.actual;
        var targetExpectSchema = expect.collections.filter(function (col) { return col.name === collection; });
        var targetActualSchema = actual.collections.filter(function (col) { return col.name === collection; });
        if (targetExpectSchema.length !== 1) {
            throw new CollectionNotFoundError(collection);
        }
        return {
            expect: targetExpectSchema[0],
            actual: targetActualSchema.length ? targetActualSchema[0] : undefined,
        };
    };
    return LazyDataMigrationProcessor;
}());
export { LazyDataMigrationProcessor };
//# sourceMappingURL=lazy-data-migration-processor.js.map